// https://github.com/typekit/webfontloader
// https://www.cdnplanet.com/blog/faster-google-webfonts-preconnect/

import createWebfontLoaderScript from './createWebfontLoaderScript'

type TFonts = readonly string[]

interface IWebFontConfig {
  google: { text?: string, families: TFonts }
  active?: TVoidCallback | undefined
  inactive?: TVoidCallback | undefined
}

interface IProps {
  readonly fonts: TFonts
  readonly text?: string
  readonly active?: TVoidCallback
  readonly inactive?: TVoidCallback
}

/**
 * Google Fonts-on keresztül az adott fontok betöltése.
 * @param props - A paraméterek, amik alapján betöltjük a fontokat.
 */
export default function webFontLoader (props: IProps): void {
  const global = window as unknown as { WebFontConfig: IWebFontConfig }

  global.WebFontConfig = {
    google: { families: props.fonts, ...(props.text?.length ? { text: props.text } : {}) },
    active: props.active,
    inactive: props.inactive
  }

  createWebfontLoaderScript()
}
